import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { useModals } from '@shared/contexts';

import { Modal } from '@components/modal';
import { ModalName } from '@components/modals/types.ts';

import { config } from '@/config.ts';

import { RegisterForm } from './components/register-form';
import * as Styled from './register-modal.styled';

const isNgu3 = config.BRAND === 'ngu3';
const isCom2 = config.BRAND === 'com2';
const isRockets = config.BRAND === 'rockets';
const isExternalBrand = isNgu3 || isRockets || isCom2;

const RegisterModal = () => {
	const { t } = useTranslation(['errors', 'reg']);
	const { isModalOpen, closeModal, openModal } = useModals();

	const handleCloseModal = () => {
		closeModal();
	};

	const handleLoginClick = () => {
		closeModal();
		openModal(ModalName.LOGIN);
	};

	return (
		<Modal
			isOpen={isModalOpen(ModalName.REGISTER)}
			closeModal={handleCloseModal}
			maxWidth={500}
			size='large'
			hasPadding={false}
			backgroundColor='dark'
			title={t('reg:register')}
			titlePosition='center'
		>
			<Styled.Wrapper>
				<Styled.Body>
					<RegisterForm shouldReload closeModal={closeModal} />

					<Styled.LoginActionWrapper>
						{t('reg:have_account')} <Styled.Action onClick={handleLoginClick}>{t('reg:to_login')}</Styled.Action>
					</Styled.LoginActionWrapper>

					{!isExternalBrand && (
						<Styled.Footer>
							<Styled.RulesWrapper>
								{t('reg:by_accepting_reg')}
								<Styled.RulesButton onClick={() => openModal(ModalName.OFFER_RULES)}>
									{t('reg:rules_terms')}
								</Styled.RulesButton>
							</Styled.RulesWrapper>
						</Styled.Footer>
					)}
				</Styled.Body>
			</Styled.Wrapper>
		</Modal>
	);
};

export default RegisterModal;
